import { createApp } from 'vue';
import App from './App';

createApp(App).mount(document.body);

// const input = document.createElement('input');
// input.addEventListener('input', (e) =>{

// })
